import * as React from "react";
import Textarea from "../../Textarea-new/Textarea";

const CONFIRM_REFRESH_MESSAGE =
    "Re-pull the default Strengths / Challenges / Buyer Pool / Qualifications / Recommendations text from the Standard Text rules? This will overwrite the current proposal text. You still need to Save to persist the change.";

const REFRESH_ROW_STYLE = {
    width: "100%",
    padding: "10px 20px 0",
    display: "flex",
    justifyContent: "flex-end",
};

const REFRESH_BTN_STYLE = {
    padding: "6px 14px",
    fontSize: "13px",
    fontWeight: 600,
    color: "#ffffff",
    backgroundColor: "#15254a",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
};

const REFRESH_BTN_DISABLED_STYLE = {
    ...REFRESH_BTN_STYLE,
    backgroundColor: "#8a93a6",
    cursor: "not-allowed",
};

const Proposal = ({
    data,
    handleChangeInput,
    viewMode,
    deleted,
    onRefreshDefaults,
    canRefreshDefaults,
}) => {
    const showRefreshButton = !viewMode && !deleted && typeof onRefreshDefaults === "function";

    const handleRefreshClick = () => {
        if (!canRefreshDefaults) return;
        if (typeof window !== "undefined" && window.confirm && !window.confirm(CONFIRM_REFRESH_MESSAGE)) return;
        onRefreshDefaults();
    };

    return (
        <div className="Notes-info">
            {showRefreshButton && (
                <div style={REFRESH_ROW_STYLE}>
                    <button
                        type="button"
                        onClick={handleRefreshClick}
                        disabled={!canRefreshDefaults}
                        style={canRefreshDefaults ? REFRESH_BTN_STYLE : REFRESH_BTN_DISABLED_STYLE}
                        title={
                            canRefreshDefaults
                                ? "Re-pull text from the Proposals > Standard Text rules"
                                : "Standard Text configuration is still loading..."
                        }
                    >
                        Refresh from Defaults
                    </button>
                </div>
            )}
            <div className="Notes-info_column Notes-info-box Website_column_item">
                <Textarea
                    name="STRENGTHS"
                    label="Strengths"
                    value={data.STRENGTHS}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isList={true}
                />
            </div>
            <div className="Notes-info_column Notes-info-box">
                <Textarea
                    name="CHALLENGES"
                    label="Challenges"
                    value={data.CHALLENGES}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isList={true}
                />
            </div>
            <div className="Notes-info_column Notes-info-box">
                <Textarea
                    name="BUYER_POOL"
                    label="Buyer Pool"
                    maxWidth="100%"
                    value={data.BUYER_POOL}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isList={true}
                />
            </div>
            <div className="Notes-info_column Notes-info-box">
                <Textarea
                    name="QUALIFICATIONS"
                    label="QUALIFICATIONS"
                    maxWidth="100%"
                    value={data.QUALIFICATIONS}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isList={true}
                />
            </div>
            <div className="Notes-info_column Notes-info-box">
                <Textarea
                    name="RECOMMENDATIONS"
                    label="RECOMMENDATIONS"
                    maxWidth="100%"
                    value={data.RECOMMENDATIONS}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isList={true}
                />
            </div>
        </div>
    );
};

export default Proposal;
